import { render, staticRenderFns } from "./codeGroup.vue?vue&type=template&id=4af5a6f6"
import script from "./codeGroup.vue?vue&type=script&lang=js"
export * from "./codeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af5a6f6')) {
      api.createRecord('4af5a6f6', component.options)
    } else {
      api.reload('4af5a6f6', component.options)
    }
    module.hot.accept("./codeGroup.vue?vue&type=template&id=4af5a6f6", function () {
      api.rerender('4af5a6f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/code/codeGroup.vue"
export default component.exports